export default {
  zh: {
    successInfo: '重置密码成功',
    ok: '确定'
  },
  en: {
    successInfo: 'Reset Password Successfully',
    ok: 'OK'
  }
}



// WEBPACK FOOTER //
// ./src/components/resetPwdSuccessNotice/lang.js